export default __webpack_public_path__ + "static/ghost-f99b8f983407476e7dd574517f0be515.png";